import styled from 'styled-components'
import { motion } from 'framer-motion'
import Img from 'next/legacy/image'

import * as colors from '../../styles/abstracts/_variables.styles'
import * as breakpoints from '../../styles/abstracts/_breakpoints'
import * as typo from '../../styles/abstracts/_typography.styles'

// Breakpoints
const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

export const GridCardSection = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  width: 90vw;
  height: auto;
  padding-top: 2rem;
  margin: auto auto;
  margin-top: 2rem;

  @media ${xxSmallDevices} {
    grid-template-rows: auto 55vh;
    margin: auto 2rem;
    width: 90vw;
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    grid-template-rows: auto 45vh;
    margin: auto 2rem;
    width: 90vw;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    grid-template-rows: auto 45vh;
    margin: auto 4rem;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
    grid-template-rows: auto 50vh;
    width: 90vw;
  }
  @media ${extraLargeDevices} {
    grid-template-rows: auto 50vh;
  }
  @media ${xxLargeDevices} {
    grid-template-rows: auto 50vh;
  }
`

export const TextContainer = styled(motion.div)`
  position: relative;
  height: auto;
  margin: 0rem;
  background: inherit;

  @media ${xxSmallDevices} {
    margin: 2rem;
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    margin: 2rem 0rem;
    width: 100%;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    margin: 4rem 0rem;
    width: 90%;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
    margin: 4rem 0rem;
  }
  @media ${extraLargeDevices} {
    margin: 4rem 0rem;
  }
  @media ${xxLargeDevices} {
    margin: 4rem 0rem;
  }
`
